import { tooManyRequestsAction } from 'actions/apiErrorActions';
import get from 'lodash/get';

const ApiErrorHandler = store => next => action => {
	const statusCode = get(action, ['error', 'ERROR_CODE']) || get(action, ['error', 'statuscode']);
	if (statusCode === 429) {
		store.dispatch(
			tooManyRequestsAction({
				errorMessage: action['error']['ERROR_MESSAGE'],
				retryTimeout: 0
			})
		);
	}
	return next(action);
};

export default ApiErrorHandler;
